












































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import { DrivewealthWizardStep } from "@/shared/types";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class InvestWithDrivewealthWidget extends Vue {
  @Prop() hasMoreThanThreshold: boolean;
  @Prop() hsaInvestmentThreshold: number;
  DrivewealthWizardStep = DrivewealthWizardStep;
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;
  SharedRoutes = SharedRoutes;

  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  drivewealthStore = useDrivewealthStore();
  userStore = useUserStore();

  get routeLocation (): Location {
    this.drivewealthStore.loadAccountIds({})
        .then(result => {
          if (this.drivewealthStore.accountIds.length < 1) {
            this.signingDocumentStore.markDeleteSignature(this.signingDocumentStore.drivewealthAccountSignatureDocumentKey);
            this.signingDocumentStore.setHsabDrivewealthAccountSignature(null);
          }});
    return (this.custodianSettingsStore.isHsaBankCustodian && !this.signingDocumentStore.hsabDrivewealthAccountSignatureIsSigned)
        ? { name: SharedRoutes.DrivewealthHsabAccountSignature, query: { redirectRoute: RouteNames.DrivewealthWizard } }
        : { name: RouteNames.DrivewealthWizard, params: { step: DrivewealthWizardStep.SelectAccountType} };
  }

  get isEmailMissing (): boolean {
    return !this.userStore.contactEmail;
  }

  get hsaInvestEnrollButtonDisabled (): boolean {
    return this.isEmailMissing || this.custodianSettingsStore.hsaInvestEnrollButtonDisabled;
  }
}

